<template>
  <div v-if="followupState.displayType !== 'none'">
    <!-- Direct Button Display -->
    <FollowUpButton
      v-if="followupState.displayType === 'button'"
      :state="followupState"
      buttonClass="btn btn-primary btn-lg mb-3 w-100"
    />

    <!-- Card Display -->
    <div v-else-if="followupState.displayType === 'card'">
      <CardRoot
        class="mb-2"
        :style="{
          border:
            'var(--phoenix-card-border-width) solid var(--phoenix-card-border-color) !important',
        }"
      >
        <CardHeader v-if="followupState.cardTitle">
          <CardTitle>
            {{ followupState.cardTitle }}
          </CardTitle>
        </CardHeader>
        <CardBody v-if="followupState.cardMessage" class="py-0">
          <p>{{ followupState.cardMessage }}</p>
        </CardBody>
        <CardFooter v-if="followupState.text">
          <FollowUpButton
            :state="followupState"
            :buttonClass="'btn btn-subtle-primary me-1 mb-1'"
          />
        </CardFooter>
      </CardRoot>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Company } from "@/types";
import { useFollowupState } from "@/composables/useFollowupState";
import FollowUpButton from "@/dashboard/common/FollowUpButton.vue";
import {
  CardBody,
  CardHeader,
  CardRoot,
  CardTitle,
  CardFooter,
} from "@/components/common/card";
const props = defineProps<{
  company: Company;
  accountId: number;
}>();
const { followupState } = useFollowupState(props.company, props.accountId);
</script>
